import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/reset.css';
import 'normalize.css'
import 'font-awesome/css/font-awesome.css';
import axios from 'axios';
import echarts from 'echarts';
import util from './common/util';
import filters from './common/filters';

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.prototype.utilFun = util;
Vue.prototype.axios = axios;
axios.defaults.baseURL = '/hw';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

(<any>Object).keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
